<template>
<div>
<h1> Search within website </h1>
<hr style='width: 100%'>
<div class='override-class' style='{ margin: "20px"}'>
    <v-container fluid>
      <v-col cols='6'>
        <v-text-field
        label='Searchtext'
        v-model='searchtext'
        > {{ searchtext }}</v-text-field>
        <v-btn color='success' @click='search'> Search </v-btn>
        <v-btn color='red' @click='reset'> Clear </v-btn>
      </v-col>
    </v-container>
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      searchtext: 'Keyword(s)...'
    }
  },
  methods: {
    search () {
      // FIXME: Implement search across website
    },
    reset () {
      this.searchtext = 'Searchtext'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/SearchComponent.vue